import React from 'react'

class LogoDesign extends React.Component {
    render() {
        return (

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
                <g fill="none" fill-rule="evenodd">
                    <path fill="#EE404A" d="M302.168 229.057l39.872-7.984-36.4-16.276c0-.048.004-.088.004-.136l32.716-54.54-47.704 16.658c-5.48-5.552-12.668-10.544-22.124-14.604-2.844-1.22-15.26-3.1-30.6-.872-30.9-19.33-60.524-55.13-77.972-73.507-26.232-27.64-44.736-21.948-44.736-21.948 13.624 18.408 23.452 70.748 23.452 70.748-2.448-11.676-35.276-46.548-35.276-46.548C60.96 31.633 32.38 36.11 32.38 36.11c28.868 31.327 35.268 87.7 35.268 87.7C51.204 97.856 29.632 91.08 23 89.556c4.6 1.928 16.224 12.316 28.5 66.56 15.828 69.936 47.912 77.016 47.912 77.016 20.552 9.744 42.82 9.76 64.556 4.496-6.076 34.11-11.368 64.96-15.428 89.023l-20.028 111.325c171.78-13.972 183.868-96.004 183.868-96.004l-23.888-80.803s8.66-13.84 13.676-32.113"/>
                    <path fill="#FEFEFE" d="M257.365 217.948l4.356-29.18-5.14-.768-4.354 29.184"/>
                    <path fill="#FEFEFE" d="M271.18 207.72L242 203.366l.768-5.136 29.18 4.35"/>
                </g>
            </svg>

        );
    }
}

export default LogoDesign



// WEBPACK FOOTER //
// ../components/SVG/LogoDesign.jsx